import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Alert } from "@mui/material";
import { nanoid } from "nanoid";
import React from "react";
import { UserMessageSeverity } from "../core/global";
import styles from "../styles/components/error-message.module.scss";
import { StyledMarkdown } from "./typeface";

interface ErrorMessageProps {
  message: string | string[] | null     // can be Markdown or string
  severity?: UserMessageSeverity
  icon?: React.ReactNode
  merge?: boolean
}

export const ErrorMessage = ({
  message,
  severity = "error",
  merge = false,
  icon = <WarningAmberIcon />,
}: ErrorMessageProps) => {
  
  if (!message) return null

  let useError = typeof message === 'string'? [message] : [...message];

  if (useError.length === 0) return null
  
  // remove duplicate messages
  useError = Array.from(new Set(useError));

  if (merge && useError.length > 1) {
    useError = [useError.join('\n\n')]
  }

  return (
    <>
      {useError.map(m => {
        return (
          <Alert icon={icon} key={nanoid()} severity={severity} className={styles.message}>
            <StyledMarkdown key={nanoid()}>{m}</StyledMarkdown>
          </Alert>
        )
      })}
    </>
  )
}

export function SuccessMessage({ message, icon }: ErrorMessageProps) {
  return <ErrorMessage severity="success" icon={icon} message={message} />
}

export function WarningMessage({ message, icon }: ErrorMessageProps) {
  return <ErrorMessage severity="warning" icon={icon} message={message} />
}

export function InfoMessage({ message, icon }: ErrorMessageProps) {
  return <ErrorMessage severity="info" icon={icon} message={message} />
}